import React, { Component } from 'react';
//import '../css/HalfSection.scss';

import circles from '../img/circles.svg';
import car from '../img/car-big.png';

const CarStyle = {
  position: 'absolute'
};
const hideCar = {
  display: 'block'
}

class HalfSection extends Component {
  constructor(props) {
    super(props);

    this.state = { stuck: true };
    this._scroll = this._scroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this._scroll);
    //document.getElementById('big-car').style.display = 'block';
  }

  render() {
    return (
      // <div ref="section" className="half-section">
      //   <h1>Partner Feature:</h1>
      //   <h2>Maternity Care Coalition</h2>

      //   <div className="half">
      //     <h3>City of Motherly Love: How a <em>Merck for Mothers</em> partner is improving health outcomes for Mothers in Philadelphia</h3>

      //     <p>Since 1980, the mission of Maternity Care Coalition (MCC) has been to improve the health and wellbeing of pregnant women and parenting families throughout Southeastern Pennsylvania. MCC has assisted more than 125,000 families in Philadelphia and beyond, focusing on neighborhoods with high rates of poverty, maternal and infant mortality, health disparities, and changing immigration patterns. Knowing that a family’s needs don’t stop immediately after childbirth, MCC offers a range of services and programs for every step along the journey of becoming a new family. </p>

      //     <p>MCC has become ubiquitous throughout the city with their branded MOMobiles, which are used to bring support and education directly to their clients across various programs.  Funded by <em>Merck for Mothers</em>, MOMobile “Safe Start” is a unique partnership between MCC, the Hospital of the University of Pennsylvania (HUP), the Penn Center for Community Health Workers, Keystone First and Community Behavioral Health. Together, they are working to address system challenges and improve health outcomes for pregnant women through comprehensive and integrated medical care.</p>

      //     <p>MOMobile Safe Start Advocates:</p>

      //     <ul>
      //       <li>Provide services like accompanying pregnant women with multiple medical problems to doctors appointments</li>
      //       <li>Emphasize helping patients navigate the complexities of high risk, hospital-based prenatal care</li>
      //       <li>Empower clients with education on their medical conditions so they can advocate for themselves and better manage their health.</li>
      //       <li>Provide labor and breastfeeding support as trained doulas</li>
      //     </ul>
        
      //     <p>Preliminary research has shown the Safe Start program is making an impact. The HUP and the Yale School of Public Health found that eligible pregnant women who participated in Safe Start had a significantly lower likelihood of receiving inadequate prenatal care, experiencing an inpatient admission, or needing an emergency room/triage visit during pregnancy than those who did not.</p>
      //     <p>&nbsp;</p>
      //     <p>&nbsp;</p>
      //   </div>

      //   <div className="circles"><img src={circles} alt="circles" /></div>
      //   <div className={this.state.stuck ? "big-car" : "big-car absolute"} style={CarStyle}><img src={car} alt="car" /></div>
      // </div>

      <div ref="section" id="section4" className="carSection inView">
          {/* <div className="bg"></div> */}
          <div ref="section4quote" id="big-car" className="big-car" style={hideCar}><img src={car} /></div>
          {/* <div ref="section4quote" className="circles"><img src={circles} /></div> */}
          <div ref="section4_left" className="section3-left">
            <div className="section3-inner">
            <h1>Partner Feature:</h1>
            <h2>Maternity Care Coalition</h2>

            <h3>City of Motherly Love: How a <em>Merck for Mothers</em> partner is improving health outcomes for Mothers in Philadelphia</h3>

           <p>Since 1980, the mission of Maternity Care Coalition (MCC) has been to improve the health and wellbeing of pregnant women and parenting families throughout Southeastern Pennsylvania. MCC has assisted more than 125,000 families in Philadelphia and beyond, focusing on neighborhoods with high rates of poverty, maternal and infant mortality, health disparities, and changing immigration patterns. Knowing that a family’s needs don’t stop immediately after childbirth, MCC offers a range of services and programs for every step along the journey of becoming a new family. </p>

           <p>MCC has become ubiquitous throughout the city with their branded MOMobiles, which are used to bring support and education directly to their clients across various programs.  Funded by <em>Merck for Mothers</em>, MOMobile “Safe Start” is a unique partnership between MCC, the Hospital of the University of Pennsylvania (HUP), the Penn Center for Community Health Workers, Keystone First and Community Behavioral Health. Together, they are working to address system challenges and improve health outcomes for pregnant women through comprehensive and integrated medical care.</p>

           <p>MOMobile Safe Start Advocates:</p>

           <ul>
             <li>Provide services like accompanying pregnant women with multiple medical problems to doctors appointments</li>
             <li>Emphasize helping patients navigate the complexities of high risk, hospital-based prenatal care</li>
             <li>Empower clients with education on their medical conditions so they can advocate for themselves and better manage their health.</li>
             <li>Provide labor and breastfeeding support as trained doulas</li>
           </ul>
        
           <p>Preliminary research has shown the Safe Start program is making an impact. The HUP and the Yale School of Public Health found that eligible pregnant women who participated in Safe Start had a significantly lower likelihood of receiving inadequate prenatal care, experiencing an inpatient admission, or needing an emergency room/triage visit during pregnancy than those who did not.</p>
           <p>&nbsp;</p>
           <p>&nbsp;</p>
            </div>
          </div>
        </div>
    );
  }

  _scroll() {
    if(window.innerWidth < 800) return;

    let height = this.refs.section.offsetHeight;
    const scroll =  document.documentElement.scrollTop || document.body.scrollTop;

    if(height - scroll > window.innerHeight && !this.state.stuck) {
      this.setState({stuck: true});
    } else {
      if(height - scroll <= window.innerHeight && this.state.stuck) {
        this.setState({stuck: false});
      }
    }
  }
}

export default HalfSection;



// WEBPACK FOOTER //
// ./src/js/HalfSection.js